/**
 * Toast UI 렌더러 — useToast의 toasts 배열을 화면에 그린다.
 * App 최상단에 <ToastProvider> 내부에서 한 번만 렌더링.
 */
import { useToast } from '@/hooks/useToast';

export function ToastContainer() {
  const { toasts, dismissToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-6 right-6 z-[100] flex flex-col gap-2"
      role="region"
      aria-label="알림"
      aria-live="polite"
    >
      {toasts.map((t) => {
        const bg =
          t.type === 'success'
            ? 'bg-emerald text-white'
            : t.type === 'error'
              ? 'bg-[#D9534F] text-white'
              : 'bg-dark text-white';

        return (
          <button
            key={t.id}
            type="button"
            onClick={() => dismissToast(t.id)}
            className={`pointer-events-auto min-w-[240px] max-w-[360px] rounded-md px-4 py-3 text-left text-sm font-medium shadow-lg animate-fade-up ${bg}`}
            aria-label={`알림 닫기: ${t.message}`}
          >
            {t.message}
          </button>
        );
      })}
    </div>
  );
}
